// src/store/index.js
import { createStore } from 'vuex'
import axios from '@/api';

export default createStore({
    state: {
        user: null,
        books: [],
        borrowRecords: [],
        userInfo: null,
        totalBookCount: 0,
        availableBookCount: 0,
        borrowedBookCount: 0,
        messages: [],
        tickets: [],
        currentTicket: null,
        ticketReplies: [],
        ticketListTotal: 0,
        borrowRecordsCount: 0,
        stats: null,
        messagePage: 1,
        messageTotal: 0,
        hasMoreMessages: true,
        isFetchingMessages: false,
        unreadMessageCount: 0,
    },
    mutations: {
        setTotalBookCount(state, count) {
            state.totalBookCount = count;
        },
        setUser(state, user) {
            state.user = user
            localStorage.setItem('user', JSON.stringify(user))
        },
        clearUser(state) {
            state.user = null
            localStorage.removeItem('user')
        },
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo;
        },
        setBooks(state, books) {
            state.books = books
        },
        addBook(state, book) {
            state.books.push(book)
        },
        removeBook(state, bookId) {
            state.books = state.books.filter(book => book.book_id !== bookId)
        },
        //setBorrowRecords(state, records) {
        //    // 不再覆盖整个记录，而是更新当前显示的记录
        //    // state.borrowRecords = records

        //    // 改为只更新单个记录的变更
        //    // 这个函数现在可能不再需要，因为数据直接存储在组件中
        //},
        //setBorrowRecordsCount(state, count) {
        //    state.borrowRecordsCount = count
        //},
        updateBorrowRecord(state, updatedRecord) {
            const index = state.borrowRecords.findIndex(r => r.record_id === updatedRecord.record_id);
            if (index !== -1) {
                state.borrowRecords.splice(index, 1, updatedRecord);
            }
        },
        setDashboardData(state, data) {
            state.userInfo = data.user_info;
            state.books = data.recent_books; // 只保存最近图书
            state.totalBookCount = data.stats.total_books;
            state.availableBookCount = data.stats.available_books;
            state.borrowedBookCount = data.stats.borrowed_books;

            // 保存借阅记录
            state.borrowRecords = data.recent_records;
            state.borrowRecordsCount = data.stats.user_borrowed_count;
            state.stats = { ...data.stats }
        },
        updateBookStatus(state, payload) {
            const { bookId, status } = payload;
            
            // 1. 更新主图书列表中的状态
            const bookIndex = state.books.findIndex(book => book.book_id === bookId);
            console.log(state.books);
            console.log(bookId);
            console.log(bookIndex);
            if (bookIndex !== -1) {
                // 使用 Vue.set 确保响应式更新
                state.books[bookIndex].state = status;
            }
            console.log(state.books);
            // 2. 更新仪表盘中的最近图书状态
            const recentBookIndex = state.recentBooks?.findIndex(book => book.book_id === bookId);
            if (recentBookIndex !== -1 && recentBookIndex !== undefined) {
                state.recentBooks[recentBookIndex].state = status;
            }
            
            // 3. 更新统计计数（可选）
            if (status === 'in') {
                state.availableBookCount++;
                state.borrowedBookCount--;
            } else if (status === 'out') {
                state.availableBookCount--;
                state.borrowedBookCount++;
            }
        },
        setMessages(state, messages) {
            state.messages = messages;
        },
        markMessageRead(state, messageId) {
            const message = state.messages.find(msg => msg.message_id === messageId);
            if (message) {
                message.read_status = 1;
            }
        },
        markAllMessagesRead(state) {
            state.messages.forEach(msg => {
                msg.read_status = 1;
            });
        },
        addMessage(state, message) {
            state.messages.unshift(message);
        },
        setTickets(state, tickets) {
            state.tickets = tickets
        },
        setCurrentTicket(state, ticket) {
            state.currentTicket = ticket
        },
        setTicketReplies(state, replies) {
            state.ticketReplies = replies
        },
        addTicket(state, ticket) {
            state.tickets.unshift(ticket)
        },
        addReply(state, reply) {
            state.ticketReplies.push(reply)
        },
        updateTicket(state, updatedTicket) {
            const index = state.tickets.findIndex(t => t.ticket_id === updatedTicket.ticket_id)
            if (index !== -1) {
                state.tickets.splice(index, 1, updatedTicket)
            }
            if (state.currentTicket && state.currentTicket.ticket_id === updatedTicket.ticket_id) {
                state.currentTicket = updatedTicket
            }
        },
        setTicketListTotal(state, total) {
            state.ticketListTotal = total
        },
        removeTicket(state, ticketId) {
            state.tickets = state.tickets.filter(t => t.ticket_id !== ticketId)
            if (state.currentTicket && state.currentTicket.ticket_id === ticketId) {
                state.currentTicket = null
            }
            state.ticketListTotal -= 1
        },
        setMessagePage(state, page) {
            state.messagePage = page;
        },

        setMessageTotal(state, total) {
            state.messageTotal = total;
        },

        setHasMoreMessages(state, hasMore) {
            state.hasMoreMessages = hasMore;
        },

        setFetchingMessages(state, isFetching) {
            state.isFetchingMessages = isFetching;
        },

        appendMessages(state, messages) {
            // 避免重复添加消息
            const existingIds = new Set(state.messages.map(m => m.message_id));
            const newMessages = messages.filter(m => !existingIds.has(m.message_id));

            state.messages = [...state.messages, ...newMessages];
        },
        setUnreadMessageCount(state, count) {
            state.unreadMessageCount = count;
        },
        // 更新标记已读的 mutation
        markMessageRead(state, messageId) {
            const message = state.messages.find(msg => msg.message_id === messageId);
            if (message && message.read_status === 0) {
                message.read_status = 1;
                state.unreadMessageCount -= 1; // 减少未读计数
            }
        },

        markAllMessagesRead(state) {
            state.messages.forEach(msg => {
                if (msg.read_status === 0) {
                    msg.read_status = 1;
                }
            });
            state.unreadMessageCount = 0; // 重置未读计数
        },

        // 添加新消息时的处理
        addMessage(state, message) {
            state.messages.unshift(message);
            if (message.read_status === 0) {
                state.unreadMessageCount += 1; // 增加未读计数
            }
        }
    },
    actions: {
        initstore({ dispatch }) {
            dispatch('loadUserFromStorage');
        },

        loadUserFromStorage({ commit }) {
            const user = localStorage.getItem('user');
            console.log(user)
            if (user) {
                commit('setUser', JSON.parse(user));
            }
        },
        async fetchUserInfo({ commit }) {
            try {
                const response = await axios.post('/api/UserInfo', { uid: localStorage.getItem('user_uid') });
                if (response.data.success) {
                    commit('setUserInfo', response.data.data);
                }
            } catch (error) {
                console.error('获取用户信息失败:', error);
            }
        },
        async fetchBooks({ commit, state }, params = {}) {
            try {
                // 设置默认参数值
                const defaultParams = {
                    //title: '',
                    page: 1,
                    page_size: 100,
                    order_by: 'created_at',
                    order_dir: 'desc'
                };
                // 合并默认参数和传入参数
                const finalParams = {
                    ...defaultParams,
                    ...params,
                    uid: localStorage.getItem('user_uid') // 始终包含用户ID
                };
                // 发送请求
                const response = await axios.post('/api/Search', finalParams);

                commit('setBooks', response.data.data);
                commit('setTotalBookCount', response.data.total);

                return response.data
            } catch (error) {
                console.error('获取书籍失败:', error)
            }
        },
        async fetchBorrowRecords({ commit, state }, params = {}) {
            try {
                const defaultParams = {
                    page: 1,
                    page_size: 10
                };

                const finalParams = {
                    ...defaultParams,
                    ...params,
                    uid: state.user.uid
                };

                const response = await axios.post('/api/GetBorrowRecords', finalParams);

                if (response.data.success) {
                    // 不再直接设置store中的借阅记录
                    // commit('setBorrowRecords', response.data.data);
                    // commit('setBorrowRecordsCount', response.data.total);

                    // 改为返回API响应，由组件处理
                    return response.data;
                }

                return response.data;
            } catch (error) {
                console.error('获取借阅记录失败:', error);
                return {
                    success: false,
                    error: error.response?.data?.error || '获取借阅记录失败'
                };
            }
        },
        async fetchDashboardData({ commit, dispatch }) {
            try {
                const response = await axios.post('/api/DashboardData', {
                    uid: localStorage.getItem('user_uid')
                });
                if (response.data.success) {
                    // 保存仪表盘数据到状态
                    commit('setDashboardData', response.data.data);
                    await dispatch('fetchMessages');
                }
            } catch (error) {
                console.error('获取仪表盘数据失败:', error);
            }
        },
        async borrowBook({ commit, state, dispatch }, bookId) {
            try {
                // 确保用户已登录
                if (!state.user) {
                    throw new Error('用户未登录');
                }

                // 发送借书请求
                const response = await axios.post('/api/BorrowBook', {
                    uid: localStorage.getItem('user_uid'),
                    book_id: bookId
                });

                // 处理成功响应
                if (response.data.success) {
                    // 更新图书状态为"已借出"
                    commit('updateBookStatus', {
                        bookId,
                        status: 'out'
                    });
                    await dispatch('fetchBorrowRecords');
                }
                return response.data
            } catch (error) {
                // 处理网络错误
                console.error('借书失败:', error);
                return {
                    success: false,
                    error: error.response?.data?.error || '网络请求失败'
                };
            }
        },
        async fetchMessages({ commit, state }, loadMore = false) {
            try {
                // 如果是加载更多且正在加载中或没有更多消息，则直接返回
                if (loadMore && (state.isFetchingMessages || !state.hasMoreMessages)) {
                    return;
                }

                commit('setFetchingMessages', true);

                // 计算要加载的页码
                const page = loadMore ? state.messagePage + 1 : 1;

                const response = await axios.post('/api/GetMessages', {
                    uid: localStorage.getItem('user_uid'),
                    page: page,
                    page_size: 15
                });

                if (response.data.success) {
                    // 如果是加载第一页，替换所有消息
                    if (!loadMore) {
                        commit('setMessages', response.data.data);
                    }
                    // 如果是加载更多，追加消息
                    else {
                        commit('appendMessages', response.data.data);
                    }

                    commit('setMessagePage', page);
                    commit('setMessageTotal', response.data.total);

                    // 计算是否还有更多消息
                    const hasMore = state.messages.length < response.data.total;
                    commit('setHasMoreMessages', hasMore);

                    // 更新未读消息计数
                    commit('setUnreadMessageCount', response.data.unread_count);
                }
            } catch (error) {
                console.error('获取消息失败:', error);
            } finally {
                commit('setFetchingMessages', false);
            }
        },
        async fetchTickets({ commit, state }, params = {}) {
            try {
                const defaultParams = {
                    page: 1,
                    page_size: 10,
                    status: '',
                    priority: ''
                }
                const finalParams = {
                    ...defaultParams,
                    ...params,
                    uid: localStorage.getItem('user_uid')
                }

                const response = await axios.get('/api/tickets', { params: finalParams })
                console.log(response)

                if (response.data.success) {
                    commit('setTickets', response.data.data)
                    commit('setTicketListTotal', response.data.total)
                    return true
                }
                return false
            } catch (error) {
                console.error('获取工单列表失败:', error)
                return false
            }
        },

        async fetchTicketDetails({ commit }, ticketId) {
            try {
                const uid = localStorage.getItem('user_uid')
                const response = await axios.get(`/api/tickets/${ticketId}`, {
                    params: { uid }
                })

                if (response.data.success) {
                    console.log(response)
                    commit('setCurrentTicket', response.data.ticket)
                    commit('setTicketReplies', response.data.replies)
                    return true
                }
                return false
            } catch (error) {
                console.error('获取工单详情失败:', error)
                return false
            }
        },

        async createTicket({ commit }, ticketData) {
            try {
                const uid = localStorage.getItem('user_uid')
                const response = await axios.post('/api/tickets', {
                    uid,
                    ...ticketData
                })

                if (response.data.success) {
                    const newTicket = {
                        ticket_id: response.data.ticket_id,
                        user_id: uid,
                        subject: ticketData.subject,
                        content: ticketData.content,
                        priority: ticketData.priority,
                        status: 'open',
                        created_at: new Date().toISOString(),
                        updated_at: new Date().toISOString()
                    }
                    commit('addTicket', newTicket)
                    return { success: true, ticket_id: response.data.ticket_id }
                }
                return { success: false, error: response.data.error }
            } catch (error) {
                console.error('创建工单失败:', error)
                return { success: false, error: error.response?.data?.error || '创建工单失败' }
            }
        },

        async replyToTicket({ commit, state }, { ticketId, content }) {
            try {
                const uid = localStorage.getItem('user_uid')
                const response = await axios.post(`/api/tickets/${ticketId}/replies`, {
                    uid,
                    content
                })

                if (response.data.success) {
                    const newReply = {
                        reply_id: response.data.reply_id,
                        ticket_id: ticketId,
                        user_id: uid,
                        content,
                        created_at: new Date(new Date().getTime() + 8 * 60 * 60 * 1000).toISOString(),
                        user_email: state.user.email,
                        user_permissions: state.user.permissions,
                        user_nickname: state.user.nickname
                    }
                    commit('addReply', newReply)

                    if (state.currentTicket && state.currentTicket.ticket_id === ticketId) {
                        const isAdmin = state.user && state.user.permissions <= 1
                        if (isAdmin) {
                            const updatedTicket = { ...state.currentTicket, status: 'processing' }
                            commit('setCurrentTicket', updatedTicket)
                            commit('updateTicket', updatedTicket)
                        }
                    }

                    return { success: true, reply_id: response.data.reply_id }
                }
                return { success: false, error: response.data.error }
            } catch (error) {
                console.error('回复工单失败:', error)
                return { success: false, error: error.response?.data?.error || '回复工单失败' }
            }
        },

        async updateTicket({ commit, state }, { ticketId, updateData }) {
            try {
                const uid = localStorage.getItem('user_uid')
                const response = await axios.put(`/api/tickets/${ticketId}`, {
                    uid,
                    ...updateData
                })

                if (response.data.success) {
                    const updatedTicket = { ...state.currentTicket, ...updateData }
                    commit('updateTicket', updatedTicket)
                    return true
                }
                return false
            } catch (error) {
                console.error('更新工单失败:', error)
                return false
            }
        },
        async deleteTicket({ commit }, ticketId) {
            try {
                const uid = localStorage.getItem('user_uid')
                const response = await axios.delete(`/api/tickets/${ticketId}`, {
                    data: { uid }  // DELETE请求通过data传递参数
                })

                if (response.data.success) {
                    // 从列表中移除工单
                    commit('removeTicket', ticketId)
                    return { success: true }
                }
                return { success: false, error: response.data.error }
            } catch (error) {
                console.error('删除工单失败:', error)
                return {
                    success: false,
                    error: error.response?.data?.error || '删除工单失败'
                }
            }
        }
    },
    getters: {
        isAdmin(state) {
            return state.user && state.user.permissions <= 1
        },
        userBorrowRecords(state) {
            if (!state.user) return []
            return state.borrowRecords.filter(record => record.user_id === state.user.uid)
        },
        totalBorrowRecords: state => state.borrowRecordsCount,
        totalBooks: state => state.totalBookCount,
        availableBooks: state => state.availableBookCount,
        borrowedBooks: state => state.borrowedBookCount,
    }
})